<template>

    <div class="container">

        <app-head title="Categories" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Categories') }}</h1>
            <div class="">
            </div>
        </div>

        <div class="card">
            <div class="card-body">

                <div class="mb-3">
                    <inertia-link :href="route('admin.categories.create', {parent_id: null})" class="btn btn-sm btn-outline-dark">
                        {{ __('Add') }}
                    </inertia-link>
                </div>

                <div class="py-1 border-bottom">
                    <div class="row align-items-center fw-bold">
                        <div class="col-5">
                            {{ __('Category') }}
                        </div>
                        <div class="col-2">
                            {{ __('Notes') }}
                        </div>
                        <div class="col-1">
                            {{ __('Enabled') }}
                        </div>
                        <div class="col-1">
                            {{ __('Products') }}
                        </div>
                        <div class="col-3">
                        </div>
                    </div>
                </div>

                <category-nodes v-for="category in categoryTree" 
                                :key="category.id" 
                                :depth="0"
                                :category="category"
                                :category-tree="categoryTree" />
            </div>
        </div>

    </div>

</template>

<script>

    import CategoryNodes from './CategoryNodes';

    export default {
        props: [
            'categoryTree',
        ],
        data() {
            return {
            }
        },
        components: {
            CategoryNodes,
        },
        mounted() {

        },
        methods: {

        }
    }
</script>